import React from 'react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary';
  className?: string;
  scrollTo?: string;
}
export function Button({
  children,
  variant = 'primary',
  className = '',
  scrollTo,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center px-8 py-4 rounded-full font-semibold text-lg transition-all duration-300 shadow-warm hover:shadow-warm-lg focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-cream';
  const variants = {
    primary: 'bg-terracotta text-white hover:bg-[#b3755d] focus:ring-terracotta hover:shadow-[0_0_20px_rgba(201,169,110,0.4)]',
    secondary: 'bg-sage text-white hover:bg-[#4a6657] focus:ring-sage'
  };
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (scrollTo) {
      document.getElementById(scrollTo)?.scrollIntoView({
        behavior: 'smooth'
      });
    }
    props.onClick?.(e);
  };
  return <button className={`${baseStyles} ${variants[variant]} ${className}`} {...props} onClick={handleClick} data-id="element-179">
      {children}
    </button>;
}